import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import NoticiaCard from '../components/NoticiaCard';
import { getImageByIndex } from '../utils/exampleImages';
import { FaNewspaper } from 'react-icons/fa';
import Breadcrumbs from '../components/Breadcrumbs';
import '../styles/PageLayout.css';
import './Noticias.css';
import '../styles/force-center.css';
import '../styles/EMERGENCY-CENTER-FIX.css';
import '../styles/FIX-CONVOCATORIAS-NOTICIAS.css';

const Noticias = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const categoriaParam = searchParams.get('categoria');

  const { data: noticias = [], isLoading, error, isError } = useQuery({
    queryKey: ['noticias'],
    queryFn: async () => {
      const response = await api.get('/noticias', { params: { _: Date.now() } });
      const data = response.data;
      return Array.isArray(data) ? data : [];
    },
    retry: 2,
    refetchOnWindowFocus: true,
    refetchOnMount: 'always',
    staleTime: 60 * 1000,
  });

  const listaNoticias = Array.isArray(noticias) ? noticias : [];

  // Filtrar noticias por búsqueda y categoría
  const filteredNoticias = listaNoticias.filter((noticia) => {
    const q = searchQuery.toLowerCase().trim();
    const titulo = String(noticia.titulo || '').toLowerCase();
    const contenido = String(noticia.contenido || '').replace(/<[^>]+>/g, '').toLowerCase();
    const matchSearch =
      !q || titulo.includes(q) || contenido.includes(q);
    const matchCategoria = !categoriaParam || noticia.categoria === categoriaParam;
    return matchSearch && matchCategoria;
  });

  if (isLoading) {
    return (
      <div className="noticias-page page-container">
        <Breadcrumbs />
        <section className="section">
          <div className="container">
            <div className="loading">Cargando noticias...</div>
          </div>
        </section>
      </div>
    );
  }

  if (isError && listaNoticias.length === 0) {
    return (
      <div className="noticias-page page-container">
        <Breadcrumbs />
        <section className="section">
          <div className="container">
            <div className="no-results">
              <h2>Error al cargar noticias</h2>
              <p>
                {error.response?.status === 404 
                  ? 'El servicio de noticias no está disponible.'
                  : error.response?.status === 500
                  ? 'Error en el servidor. Por favor, intenta más tarde.'
                  : 'No se pudo conectar al servidor. Verifica tu conexión a internet.'}
              </p>
              <p style={{ fontSize: '0.9em', color: '#666', marginTop: '1rem' }}>
                Código de error: {error.response?.status || 'Sin conexión'}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="noticias-page page-container">
      <Breadcrumbs />
      <section className="section">
        <div className="container">
          <div className="page-header">
            <div className="page-header-icon"><FaNewspaper /></div>
            <div>
              <h1 className="page-title">Noticias</h1>
              <p>Mantente informado sobre las últimas noticias del Diócesis de Ipiales</p>
            </div>
          </div>

          <div className="search-bar">
            <input
              type="text"
              placeholder="Buscar noticias..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div>

          {filteredNoticias.length === 0 ? (
            <div className="no-results">
              <p>
                {listaNoticias.length === 0
                  ? 'No hay noticias publicadas en este momento o no se pudo cargar el listado. Recargue la página (Ctrl+F5).'
                  : 'No se encontraron noticias con ese criterio de búsqueda.'}
              </p>
            </div>
          ) : (
            <div className="noticias-grid">
              {filteredNoticias.map((noticia, index) => (
                <NoticiaCard
                  key={noticia.id}
                  noticia={noticia}
                  fallbackImageSrc={getImageByIndex(index, 'gobierno')}
                >
                  <div className="noticia-content">
                    <div className="noticia-fechas">
                      {noticia.facebook_url && (
                        <span className="noticia-fb-chip" title="Publicación vinculada a Facebook">
                          Facebook
                        </span>
                      )}
                      <span className="noticia-fecha">
                        {new Date(noticia.fecha_publicacion || noticia.creado_en).toLocaleDateString('es-CO')}
                      </span>
                      {(noticia.actualizado_en || noticia.fecha_actualizacion) &&
                       new Date(noticia.actualizado_en || noticia.fecha_actualizacion).getTime() !==
                       new Date(noticia.fecha_publicacion || noticia.creado_en).getTime() && (
                        <span className="noticia-actualizacion">
                          Actualizado: {new Date(noticia.actualizado_en || noticia.fecha_actualizacion).toLocaleDateString('es-CO')}
                        </span>
                      )}
                    </div>
                    <h2>{noticia.titulo}</h2>
                    <p>
                      {noticia.resumen ||
                        `${String(noticia.contenido || '').replace(/<[^>]+>/g, '').substring(0, 200)}…`}
                    </p>
                  </div>
                </NoticiaCard>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Noticias;


